if (!customElements.get('shoppable-slideshow-component')) {
  customElements.define(
    'shoppable-slideshow-component',
    class extends HTMLElement {
      constructor() {
        super();
        if (this.dataset.enableSlider !== 'true') return;

        this.slidesDesktop = 4.5;
        this.slidesMobile = 1.3;
        this.autoplayDelay = 3000;
        this.isTransitioning = false;

        this.initSlider();
      }

      initSlider() {
        const wrapper = this.closest('.video-shoppable-wrapper');

        const options = {
          slidesPerGroup: 1,
          loop: true,
          grabCursor: true,
          threshold: 2,
          centeredSlides: false,
          breakpoints: {
            0: { slidesPerView: this.slidesMobile, spaceBetween: 10 },
            768: { slidesPerView: this.slidesDesktop, spaceBetween: 15 }
          },
          autoplay: {
            delay: this.autoplayDelay,
            disableOnInteraction: false
          },
          pagination: {
            el: wrapper?.querySelector('.swiper-pagination'),
            clickable: true
          },
          navigation: {
            nextEl: wrapper?.querySelector('.custom-swiper-button-next'),
            prevEl: wrapper?.querySelector('.custom-swiper-button-prev')
          },
          on: {
            init: (swiper) => {
              this.setupCustomControls(swiper);
              this.updateVideoStates(swiper);
            },
            slideChangeTransitionStart: (swiper) => {
              this.isTransitioning = true;
              this.pauseAllVideos(swiper);
            },
            slideChangeTransitionEnd: (swiper) => {
              this.isTransitioning = false;
              this.updateVideoStates(swiper);
            }
          }
        };

        this.sliderInstance = new window.FoxTheme.Carousel(
          this,
          options,
          [
            FoxTheme.Swiper.Autoplay,
            FoxTheme.Swiper.Pagination,
            FoxTheme.Swiper.Navigation
          ]
        );

        this.sliderInstance.init();
      }

      setupCustomControls(swiper) {
        this.querySelectorAll('.video-play-overlay').forEach(playBtn => {
          playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const videoContainer = playBtn.closest('.video-item-inner');
            const video = videoContainer.querySelector('.media-video');
            const slide = playBtn.closest('.swiper-slide');
            this.handlePlayClick(video, slide, swiper);
          });
        });

        this.querySelectorAll('.video-sound-overlay').forEach(soundBtn => {
          soundBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const videoContainer = soundBtn.closest('.video-item-inner');
            const video = videoContainer.querySelector('.media-video');
            const slide = soundBtn.closest('.swiper-slide');
            this.handleSoundClick(video, slide, swiper);
          });
        });

        this.querySelectorAll('.media-video').forEach(video => {
          video.addEventListener('play', () => {
            const container = video.closest('.video-item-inner');
            container.classList.add('is-playing');
          });

          video.addEventListener('pause', () => {
            const container = video.closest('.video-item-inner');
            container.classList.remove('is-playing');
          });

          video.addEventListener('ended', () => {
            const container = video.closest('.video-item-inner');
            container.classList.remove('is-playing');
            video.currentTime = 0;

            swiper.slideNext();
            setTimeout(() => {
              if (!this.isTransitioning) {
                swiper.autoplay.start();
              }
            }, 100);
          });

          video.addEventListener('timeupdate', () => {
            const slide = video.closest('.swiper-slide');
            const bar = slide.querySelector('.progress-bar');
            if (bar && video.duration) {
              bar.style.width = (video.currentTime / video.duration) * 100 + '%';
            }
          });
        });
      }

      handlePlayClick(video, slide, swiper) {
        if (this.isTransitioning) return;

        const isActiveSlide = slide.classList.contains('swiper-slide-active');

        swiper.autoplay.stop();
        this.pauseAllVideos(swiper);

        if (!isActiveSlide) {
          const realIndex = this.getRealSlideIndex(slide);
          if (realIndex !== -1) {
            swiper.slideToLoop(realIndex, 300);
            setTimeout(() => {
              if (!this.isTransitioning) {
                const activeSlide = swiper.slides[swiper.activeIndex];
                const activeVideo = activeSlide?.querySelector('.media-video');
                activeVideo?.play().catch(() => {});
              }
            }, 350);
          }
        } else {
          video.play().catch(() => {});
        }
      }

      handleSoundClick(video, slide, swiper) {
        if (this.isTransitioning) return;

        const isActiveSlide = slide.classList.contains('swiper-slide-active');
        const videoContainer = video.closest('.video-item-inner');
        const currentlyMuted = video.muted;

        if (!isActiveSlide) {
          swiper.autoplay.stop();
          this.pauseAllVideos(swiper);

          const realIndex = this.getRealSlideIndex(slide);
          if (realIndex !== -1) {
            swiper.slideToLoop(realIndex, 300);
            setTimeout(() => {
              if (!this.isTransitioning) {
                const activeSlide = swiper.slides[swiper.activeIndex];
                const activeVideo = activeSlide?.querySelector('.media-video');
                const activeContainer = activeSlide?.querySelector('.video-item-inner');

                if (activeVideo && activeContainer) {
                  activeVideo.muted = !currentlyMuted;
                  activeContainer.classList.toggle('is-unmuted', !activeVideo.muted);
                  activeVideo.play().catch(() => {});
                }
              }
            }, 350);
          }
        } else {
          video.muted = !video.muted;
          videoContainer.classList.toggle('is-unmuted', !video.muted);
          swiper.autoplay.stop();
          if (video.paused) video.play().catch(() => {});
        }
      }

      getRealSlideIndex(slide) {
        const swiper = this.sliderInstance.slider;
        if (swiper.params.loop) {
          const index = slide.getAttribute('data-swiper-slide-index');
          if (index !== null) return parseInt(index);
        }
        return swiper.slides.indexOf(slide);
      }

      pauseAllVideos(swiper) {
        swiper.slides.forEach(slide => {
          const video = slide.querySelector('.media-video');
          const container = slide.querySelector('.video-item-inner');
          const bar = slide.querySelector('.progress-bar');

          if (video) {
            video.pause();
            video.currentTime = 0;
            video.muted = true;
          }
          container?.classList.remove('is-playing', 'is-unmuted');
          if (bar) bar.style.width = '0%';
        });
      }

      updateVideoStates(swiper) {
        if (!swiper || this.isTransitioning) return;

        const activeSlide = swiper.slides[swiper.activeIndex];
        const video = activeSlide?.querySelector('.media-video');

        if (video && video.paused) {
          swiper.autoplay.stop();
          video.play().catch(() => {});
        }
      }
    }
  );
}
